import { useEffect } from "react";
import {
  useOrdersStore,
  useInitializeOrderPermissions,
} from "./use-orders-store";
import OrderAll from "./order-all";
import { useBranches } from "@/hooks/useBranches";
import { useAuth } from "@/hooks/useAuth";

// Full screen loading component for initial load
const FullScreenLoading = () => (
  <div className="min-h-screen bg-gray-50 flex items-center justify-center">
    <div className="flex flex-col items-center gap-4">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
      <p className="text-gray-600 text-sm">Cargando órdenes del día...</p>
    </div>
  </div>
);

export default function OrderApp() {
  // Initialize permissions
  useInitializeOrderPermissions();
  const hasInitiallyFetched = useOrdersStore(
    (state) => state.hasInitiallyFetched,
  );

  const isLoading = useOrdersStore((state) => state.isLoading);
  const { fetchBranches } = useBranches();
  const {
    isLoading: authLoading,
    userDataLoading,
    isManager,
    user,
  } = useAuth();

  useEffect(() => {
    useOrdersStore.getState().fetchPaginatedOrdersCurrentDay();
    useOrdersStore.getState().fetchCurrentDayOrdersCounts();
  }, [hasInitiallyFetched]);

  // Ensure branches are fetched once when auth is ready
  useEffect(() => {
    const authReady =
      !authLoading && !userDataLoading && (!isManager || Boolean(user?.email));
    if (authReady) {
      fetchBranches().catch(() => {});
    }
  }, [authLoading, userDataLoading, isManager, user?.email, fetchBranches]);

  if (isLoading) {
    return <FullScreenLoading />;
  }

  return (
    <div className="min-h-screen">
      <OrderAll />
    </div>
  );
}
